import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import GuardRoute from './GuardRoute';
import { role, redirectLoggedInUserUrl } from '~redux/profile/selectors';
import { createStructuredSelector } from 'reselect';

const selector = createStructuredSelector({
  role,
  redirectLoggedInUserUrl,
});

export default withRouter(
  connect(
    selector,
    null,
  )(GuardRoute),
);
